import { Container } from "@mui/material";
import styled from "styled-components";

export const TutorialContainer = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
`;

export const TutorialBody = styled.div`
    flex: 1;
    width: 100%;
    min-width: 240px;
    overflow: auto;
`;

export const TutorialContent = styled(Container).attrs({
    maxWidth: "lg",
    sx: {
        display: "flex",
        width: "100%",
        minWidth: "240px",
        flexDirection: "column",
        alignItems: "center",
        padding: "80px 20px",
    }
})`
`;

